import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import clsx from "clsx";

import {
  Context,
  subjectRegistrationPath,
  bulkRegisterTeacherSubjectsPath,
} from "../../../managerStore";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";
import { titles } from "../../../constants/titles";
import ToolTip from "../../../atoms/ToolTip";
import { ReactComponent as SharedIcon } from "../../../assets/icon/shared_box.svg";

import styles from "./Subjects.module.scss";

const Subjects = () => {
  const { state } = useContext(Context);
  const history = useHistory();
  const { currentYear } = useCurrentYear();

  const teachers = state.teachers.map(teacher => {
    const teacherSubject = state.teacher_subjects_by_school.find(
      data => data.teacher_id === teacher.id,
    );

    return {
      ...teacher,
      subjects: teacherSubject?.subjects ?? [],
      co_used_subjects: teacherSubject?.co_used_subjects ?? [],
    };
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h3 className="me-4 mb-0">{titles.subjects}</h3>
        <div>
          <p>{currentYear}年度LOUNGEを利用する先生の教科を登録してください。</p>
          <p>※教科設定は先生画面LOUNGEでも可能です</p>
        </div>
      </div>
      <div className={styles.btnArea}>
        <button
          className="btn btn-outline-primary"
          onClick={() => history.push(bulkRegisterTeacherSubjectsPath)}
        >
          教科一括編集
        </button>
      </div>
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>ID</th>
            <th>名前</th>
            <th>メールアドレス</th>
            <th className={styles.subjectAndClassHeading}>
              <span className={styles.heading}>教科</span>
              <span className={styles.heading}>教科担当クラス</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {teachers.map(teacher => (
            <tr key={teacher.id}>
              <td>{teacher.id}</td>
              <td>
                {teacher.last_name} {teacher.first_name}
              </td>
              <td>{teacher.email}</td>
              <td className={styles.subjectAndClass}>
                <div>
                  <ul>
                    {teacher.subjects.map(subject => (
                      <li className={styles.item} key={subject.subject_id}>
                        <div className={styles.subjectName}>
                          {subject.subject_name}
                        </div>
                        <ul className={styles.classList}>
                          {subject.klasses.map((klass, index) => (
                            <li key={klass.klass_id}>
                              {klass.klass_name}
                              {index < subject.klasses.length - 1 && "、　"}
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                    {teacher.co_used_subjects.map(subject => (
                      <li
                        className={styles.item}
                        key={`co-used-${subject.subject_id}`}
                      >
                        <div className={styles.subjectName}>
                          {subject.subject_name}
                          <ToolTip
                            content={[
                              "共同で利用中",
                              "",
                              ...subject.assigned_teachers.map(
                                assignedTeacher => assignedTeacher.full_name,
                              ),
                            ].join("\n")}
                          >
                            <SharedIcon className={styles.sharedIcon} />
                          </ToolTip>
                        </div>
                        <ul className={styles.classList}>
                          {subject.klasses.map((klass, index) => (
                            <li key={klass.klass_id}>
                              {klass.klass_name}
                              {index < subject.klasses.length - 1 && "、　"}
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              </td>
              <td className={clsx("text-center", styles.utilBtnArea)}>
                <button
                  className={"btn btn-outline"}
                  onClick={() =>
                    history.push(`${subjectRegistrationPath}/${teacher.id}`)
                  }
                >
                  教科登録
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Subjects;
